import type { OriginActionValueType } from '@/lib/analytics/Avo';
import { OriginView, workItemViewed } from '@/lib/analytics/Avo';
import { TabValue } from '@/lib/types/itemPanel';

const mapPanelTabToOriginView = (panelTab?: string) => {
  switch (panelTab) {
    case TabValue.CUSTOM_FIELDS:
      return OriginView.CUSTOM_FIELDS;
    case TabValue.DEPENDENCIES:
      return OriginView.DEPENDENCIES;
    case TabValue.SYSTEM:
      return OriginView.SYSTEM_FIELDS;
    case TabValue.PLAN_SCHEDULING:
      return OriginView.SCHEDULING;
    default:
      return OriginView.SCHEDULING;
  }
};

export const trackWorkItemViewed = (
  panelTab: string | undefined,
  originAction: OriginActionValueType,
) => {
  workItemViewed({
    originView: mapPanelTabToOriginView(panelTab),
    originAction,
  });
};
